export default __webpack_public_path__ + "static/media/storageUnit1-afterC-768w.ce66e102.webp";